import { useSeoMeta } from '@unhead/react'
import Nav from '@/components/Nav'
import Hero from '@/components/Hero'
import Calculator from '@/components/Calculator'
import DeviceHubs from '@/components/DeviceHubs'
import Faq from '@/components/Faq'
import Footer from '@/components/Footer'

function Home() {
  useSeoMeta({
    title: 'Extend Battery Life: Ultimate Device Configurator',
    description: 'Expert checklists, diagnostics & configurations to extend iPhone, Android, MacBook & Apple Watch battery life by 30%+. Free interactive calculator.',
    ogTitle: 'Extend Battery Life: Ultimate Device Configurator',
    ogDescription: 'Free interactive calculator + expert blueprints to extend your device battery lifespan by 30%+.',
    ogImage: 'https://www.savingbattery.com/og-image.jpg',
    ogUrl: 'https://www.savingbattery.com/',
    ogType: 'website',
    twitterCard: 'summary_large_image',
    twitterTitle: 'Extend Battery Life — Ultimate Device Configurator',
    twitterDescription: 'Free calculator + expert blueprints for iPhone, Android, MacBook & Apple Watch.',
    twitterImage: 'https://www.savingbattery.com/og-image.jpg',
  })

  return (
    <div className="min-h-screen bg-bone text-slate-900">
      <Nav />
      <main>
        <Hero />
        <Calculator />
        <DeviceHubs />
        <Faq />
      </main>
      <Footer />
    </div>
  )
}

export default Home
